import React from "react";
import { useAuth } from "../../auth/useAuth.js";

const auctionGroups = [
  { key: "copart", label: "Copart (US)", statusKey: "copart" },
  { key: "copartCanada", label: "Copart Canada", statusKey: "copartCanada" },
  { key: "iaai", label: "IAAI (US)", statusKey: "iaai" },
  { key: "iaaiCanada", label: "IAAI Canada", statusKey: "iaaiCanada" },
];

export default function Accounts() {
  const { user } = useAuth();
  const accounts = user?.accounts ?? {};
  const statuses = user?.statuses ?? {};
  const currentIds = user?.currentAccountIds ?? {};

  return (
    <div className="card">
      <div className="card__title">Accounts (master / secondary)</div>
      <div className="grid grid-2">
        {auctionGroups.map((g) => {
          const raw = accounts[g.key];
          const list = Array.isArray(raw) ? raw : [];
          const isActive = statuses[g.statusKey] === "Active";
          const currentId = currentIds[g.key];
          return (
            <div
              key={g.key}
              style={{
                padding: 16,
                border: "1px solid var(--color-border)",
                borderRadius: 10,
                background: "var(--color-bg-card-elevated)",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <b>{g.label}</b>
                <span className={`badge ${isActive ? "active" : "inactive"}`}>
                  {isActive ? "Active" : "Inactive"}
                </span>
              </div>
              {list.length === 0 ? (
                <p className="small muted">No accounts linked.</p>
              ) : (
                <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 6 }}>
                  {list.map((acc, idx) => {
                    const isCurrent = String(acc.id) === String(currentId);
                    const labelName = acc.type === "master" ? "Master" : acc.type === "slave" ? "Secondary" : acc.type || "Account";
                    const states = Array.isArray(acc.states) ? acc.states.join(", ") : "";
                    return (
                      <li key={acc.id ?? idx} style={accRowStyle(isCurrent)}>
                        <div>
                          <div className="small" style={{ fontWeight: 600 }}>
                            {labelName}
                            {isCurrent && <span className="badge active" style={{ marginLeft: 8 }}>current</span>}
                          </div>
                          {acc.buyer_number && (
                            <div className="small muted">Buyer #{acc.buyer_number}</div>
                          )}
                          {states && <div className="small muted">States: {states}</div>}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function accRowStyle(isCurrent) {
  return {
    padding: "8px 10px",
    borderRadius: 8,
    background: isCurrent ? "#ecfdf5" : "#fff",
    border: `1px solid ${isCurrent ? "#86efac" : "var(--color-border)"}`,
  };
}
